import { render } from "./collectRecord.vue?vue&type=template&id=c6fcce62&scoped=true"
import script from "./collectRecord.vue?vue&type=script&lang=js"
export * from "./collectRecord.vue?vue&type=script&lang=js"

import "./collectRecord.vue?vue&type=style&index=0&id=c6fcce62&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6fcce62"]])

export default __exports__